import React, { useState, useRef, useEffect, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Transition } from "utils";

import { routes } from "consts";
import { AuthContext } from "store/auth/AuthContext";
import { PaziaAvatarPlaceholder } from "./molecules/UserAvatar/PaziaAvatarPlaceholder";
import { brandSystemName } from "../branding";

interface DropdownProfileProps {
  align: "right";
}
export const DropdownProfile = ({ align }: DropdownProfileProps): JSX.Element => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const navigate = useNavigate();
  const {
    state: { me },
  } = useContext(AuthContext);

  const trigger = useRef(null);
  const dropdown = useRef(null);

  // close on click outside
  useEffect(() => {
    // @ts-ignore
    const clickHandler = ({ target }) => {
      if (!dropdown.current) return;
      if (
        !dropdownOpen ||
        // @ts-ignore
        dropdown.current.contains(target) ||
        // @ts-ignore
        trigger.current.contains(target)
      )
        return;
      setDropdownOpen(false);
    };
    document.addEventListener("click", clickHandler);
    return () => document.removeEventListener("click", clickHandler);
  });

  // close if the esc key is pressed
  useEffect(() => {
    // @ts-ignore
    const keyHandler = ({ keyCode }) => {
      if (!dropdownOpen || keyCode !== 27) return;
      setDropdownOpen(false);
    };
    document.addEventListener("keydown", keyHandler);
    return () => document.removeEventListener("keydown", keyHandler);
  });

  const signOut = () => {
    localStorage.removeItem("api_token");
    navigate(routes.LOGIN);
    window.location.reload();
  };
  return (
    <div className="relative inline-flex">
      <button
        ref={trigger}
        className="inline-flex justify-center items-center group"
        aria-haspopup="true"
        onClick={() => setDropdownOpen(!dropdownOpen)}
        aria-expanded={dropdownOpen}
      >
        <PaziaAvatarPlaceholder firstName={me.firstName} surname={me.surname} size="small" />
        <div className="flex items-center truncate">
          <span className="truncate ml-2 text-sm font-medium dark:text-slate-300 group-hover:text-slate-800 dark:group-hover:text-slate-200 md:inline-block hidden">
            {me.email}
          </span>
          <svg className="w-3 h-3 shrink-0 ml-1 fill-current text-slate-400" viewBox="0 0 12 12">
            <path d="M5.9 11.4L.5 6l1.4-1.4 4 4 4-4L11.3 6z" />
          </svg>
        </div>
      </button>

      <Transition
        className={`origin-top-right z-10 absolute top-full min-w-44 bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 py-1.5 rounded shadow-lg overflow-hidden mt-1 ${
          align === "right" ? "right-0" : "left-0"
        }`}
        show={dropdownOpen}
        enter="transition ease-out duration-200 transform"
        enterStart="opacity-0 -translate-y-2"
        enterEnd="opacity-100 translate-y-0"
        leave="transition ease-out duration-200"
        leaveStart="opacity-100"
        leaveEnd="opacity-0"
      >
        <div ref={dropdown} onFocus={() => setDropdownOpen(true)} onBlur={() => setDropdownOpen(false)}>
          <div className="pt-0.5 pb-2 px-3 mb-1 border-b border-slate-200 dark:border-slate-700">
            <div className="font-medium text-slate-800 dark:text-slate-100">{brandSystemName}</div>
            <div className="text-xs text-slate-500 dark:text-slate-400 italic">Administrator</div>
          </div>
          <ul>
            <li>
              <Link
                className="font-medium text-sm text-slate-500 hover:text-slate-600 dark:hover:text-slate-400 flex items-center py-1 px-3"
                to={routes.SETTINGS()}
                onClick={() => setDropdownOpen(!dropdownOpen)}
              >
                Ustawienia
              </Link>

              <Link
                className="font-medium text-sm text-slate-500 hover:text-slate-600 dark:hover:text-slate-400 flex items-center py-1 px-3"
                to={routes.LOGS}
                onClick={() => setDropdownOpen(!dropdownOpen)}
              >
                Logi systemowe
              </Link>
            </li>
            <li>
              <button
                className="font-medium text-sm text-indigo-500 hover:text-indigo-600 dark:hover:text-indigo-400 flex items-center py-1 px-3"
                onClick={signOut}
              >
                Wyloguj
              </button>
            </li>
          </ul>
        </div>
      </Transition>
    </div>
  );
};
